import type { AppNotification } from '../services/api';

/** Matches Ai-Tempo Header — API may return boolean or 0/1. */
export function isNotificationUnread(isRead: unknown): boolean {
  return isRead === false || isRead === 0 || isRead === '0';
}

export function countUnreadNotifications(
  groups: Record<string, AppNotification[]> | null | undefined,
): number {
  if (!groups) return 0;
  let count = 0;
  for (const key of Object.keys(groups)) {
    const items = groups[key];
    if (!Array.isArray(items)) continue;
    for (const item of items) {
      if (isNotificationUnread(item.is_read)) count++;
    }
  }
  return count;
}

export function formatNotificationBadgeCount(count: number): string {
  return String(count);
}
